export const filterSvalbard =
  (svalbard) =>
  ({ forSvalbard }) =>
    forSvalbard === undefined ||
    (forSvalbard === true && svalbard) ||
    (forSvalbard === false && !svalbard);
